import { ProductFilters, RequestCategory } from '@atlassian/notification-common/types';
export var resetNotificationListFiltersStore = function resetNotificationListFiltersStore(categoryFilters, productFilters) {
  return function (_ref) {
    var getState = _ref.getState,
      setState = _ref.setState;
    setState({
      selectedFilters: {
        categoryFilter: RequestCategory.DIRECT,
        readStateFilter: getState().selectedFilters.readStateFilter,
        productFilter: ProductFilters.ANY
      },
      categoryFilters: categoryFilters,
      productFilters: productFilters
    });
  };
};